var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { mortgageData, templates } = options;  
__p+='\n\n<div>\n  <ul class="list-unstyled chart-legend" id="MortgageLegendList">\n    '+
((__t=( templates.principal({mortgageData, templates}) ))==null?'':__t)+
'\n    '+
((__t=( templates.tertiary({mortgageData, templates}) ))==null?'':__t)+
'\n    '+
((__t=( templates.insurance({mortgageData, templates}) ))==null?'':__t)+
'\n    '+
((__t=( templates.hoa({mortgageData, templates}) ))==null?'':__t)+
'\n    '+
((__t=( templates.insuranceField({mortgageData, templates}) ))==null?'':__t)+
'\n  </ul>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/payment/legend/legend.jst.ejs